<lms-breadcrumb></lms-breadcrumb>

<mat-tab-group
  class="tab-group"
  #tabGroup
  animationDuration="0ms"
  disableRipple="true"
  (selectedTabChange)="tabsManager.setTab($event)"
>
  <mat-tab *lmsProfileGuard="'documents.list'" label="documents">
    <ng-template mat-tab-label>{{ 'clients.tabs.documents' | translate }}</ng-template>
    <ng-template matTabContent>
      <lms-toolbar>
        <lms-search-field [listId]="clientDocumentslistId"></lms-search-field>
        <lms-items-count-selector [listId]="clientDocumentslistId"></lms-items-count-selector>
        <div class="lms-toolbar__item">
          <lms-print></lms-print>
        </div>
        <div class="lms-toolbar__item">
          <gl-button
            color-primary
            [text]="'documents.create' | translate"
            [routerLink]="['/documents/new']"
            title="{{ 'documents.create' | translate }}"
            *lmsProfileGuard="'documents.create'"
          ></gl-button>
        </div>
      </lms-toolbar>
      <lms-documents-list
        [listId]="clientDocumentslistId"
        [options]="{ filters: filters, sort: '-created_at' }"
      ></lms-documents-list>
    </ng-template>
  </mat-tab>
  <mat-tab *lmsProfileGuard="'customizations.list'" label="customizations">
    <ng-template mat-tab-label>{{ 'clients.tabs.customizations' | translate }}</ng-template>
    <ng-template matTabContent>
      <lms-toolbar>
        <lms-search-field [listId]="clientCustomizationslistId"></lms-search-field>
        <lms-items-count-selector [listId]="clientCustomizationslistId"></lms-items-count-selector>
        <div class="lms-toolbar__item">
          <lms-print></lms-print>
        </div>
        <div class="lms-toolbar__item">
          <gl-button
            color-primary
            [text]="'customizations.create' | translate"
            [routerLink]="['/customizations/new']"
            title="{{ 'customizations.create' | translate }}"
            *lmsProfileGuard="'customizations.create'"
          ></gl-button>
        </div>
      </lms-toolbar>
      <lms-customizations-list
        [listId]="clientCustomizationslistId"
        [options]="{ filters: filters, sort: '-created_at' }"
      ></lms-customizations-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
